import type { IntlKey } from 'locales';
import type { QuoteFormError } from 'state/addonForm/addonForm.selector';

export function addRejectionError(
  previousValidationErrors: readonly QuoteFormError[],
  rejectionErrorKey: IntlKey,
): readonly QuoteFormError[] {
  const newRejection: QuoteFormError = {
    translationKey: rejectionErrorKey,
    severity: 'Error',
    fields: [],
    values: {},
  };

  if (previousValidationErrors.some(error => error.translationKey === newRejection.translationKey)) {
    return previousValidationErrors;
  }

  return [...previousValidationErrors, newRejection];
}

export function removeRejectionError(previousValidationErrors: readonly QuoteFormError[]): readonly QuoteFormError[] {
  return previousValidationErrors.filter(error => !error.translationKey?.startsWith('tradeRejection.'));
}
